<div class='configuration-email-jobs-tab-2-part'>
	This is configuration-email-jobs tab 2
</div>